import { useMemo } from 'react';

export const useDeviceOperationSystems = () => {
  const deviceOperationSystems = useMemo(() => {
    const isIPad = navigator.userAgent.match(/iPad/i) != null;
    const isIPhone = !isIPad && ((navigator.userAgent.match(/iPhone/i) != null) || (navigator.userAgent.match(/iPod/i) != null));
    return {
      isIOS: isIPad || isIPhone,
      isAndroid: !(isIPad || isIPhone) && navigator.userAgent.match(/android/i) != null
    } as const;
  }, []);

  return deviceOperationSystems;
};
